import { FETCH_REMAKE_REPORT_RES } from '../actions/types';

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_REMAKE_REPORT_RES: {
      // Flatten orders → line_items → remakes with context
      const remakes = [];
      for (const order of action.payload) {
        for (const item of order.line_items || []) {
          for (const remake of item.remakes || []) {
            remakes.push({
              orderId: order._id,
              orderNumber: order.ticket_name,
              originalDrink: item.name,
              lineItemUid: item.uid,
              reason: remake.reason,
              created_at: remake.created_at,
            });
          }
        }
      }
      // Sort by created_at descending (newest first)
      return remakes.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );
    }
    default:
      return state;
  }
}
